import { render, staticRenderFns } from "./comp_AppRouteLoadingBar.vue?vue&type=template&id=36b2e980&scoped=true&"
import script from "./comp_AppRouteLoadingBar.vue?vue&type=script&lang=js&"
export * from "./comp_AppRouteLoadingBar.vue?vue&type=script&lang=js&"
import style0 from "./comp_AppRouteLoadingBar.vue?vue&type=style&index=0&id=36b2e980&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2e980",
  null
  
)

export default component.exports